import styles from "./custom-input-checkbox.module.scss";

const CustomInputCheckbox = ({ label, options = [], value = [], onChange, col = 12, error, required = false, direction = "horizontal" }) => {
	let colClass = styles.col12;
	if (col === 3) colClass = styles.col3;
	else if (col === 6) colClass = styles.col6;

	const handleCheckboxChange = (optionValue) => {
		const newValue = value.includes(optionValue) ? value.filter((v) => v !== optionValue) : [...value, optionValue];
		onChange(newValue);
	};

	const groupClass = direction === "vertical" ? styles.checkboxGroupVertical : styles.checkboxGroup;

	return (
		<div className={`${styles.field} ${colClass}`}>
			{label && (
				<label className={styles.label}>
					{label}
					{required && <span style={{ color: "#d32f2f", marginLeft: "4px" }}>*</span>}
				</label>
			)}
			<div className={groupClass}>
				{options.map((option) => (
					<div key={option.value} className={styles.checkboxItem}>
						<input
							type="checkbox"
							id={`checkbox-${option.value}`}
							checked={value.includes(option.value)}
							onChange={() => handleCheckboxChange(option.value)}
						/>
						<label htmlFor={`checkbox-${option.value}`}>{option.label}</label>
					</div>
				))}
			</div>
			{error && <div className={styles.error}>{error}</div>}
		</div>
	);
};

export default CustomInputCheckbox;
